import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class IntentService {
  
  private baseUrl = `${environment.smartPortalApiUrl}Intent`;
  private seedFunctionBaseUrl = `${environment.seedFunctionApiUrl}`; // Durable Function base URL (e.g., Azure Function App URL)
  
  constructor(private httpClient: HttpClient) { }
  
  getIntents(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}`);
  }

  getEntities(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/entities`);
  }

  getIntentsForWeb(kbItemId: string | null): Observable<any> {
    const url = kbItemId ? `intents-for-web/${kbItemId}` : 'intents-for-web';
    return this.httpClient.get(`${this.baseUrl}/${url}`);
  }

  getIntentsForVoiceSMS(kbItemId: string | null): Observable<any> {
    const url = kbItemId ? `intents-for-phone/${kbItemId}` : 'intents-for-phone';
    return this.httpClient.get(`${this.baseUrl}/${url}`);
  }


  getIntent(id: string): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/${id}`);
  }

  addIntent(intent: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl, intent);
  }

  updateIntent(id: string, intent: any): Observable<any> {
    return this.httpClient.put<any>(`${this.baseUrl}/${id}`, intent);
  }

  deleteIntent(id: string): Observable<any> {
    return this.httpClient.delete<any>(`${this.baseUrl}/${id}`);
  }

  // Trigger Durable Function
  startDataSeed(organizationId: string, knowledgeIndexId: number): Observable<any> {
    return this.httpClient.post<any>(`${this.seedFunctionBaseUrl}/api/StartProcess`, null, {
      params: { organizationId, knowledgeIndexId }
    });
  }

  // Check Durable Function status
  getDataSeedStatus(organizationId: string): Observable<any> {
    return this.httpClient.get<any>(`${this.seedFunctionBaseUrl}/api/GetStatus`, {
      params: { organizationId }
    });
  }

}
